

































import { Component, Vue, Prop, Watch } from "vue-property-decorator";

@Component
export default class EvaluasiKeperawatanCard extends Vue {
  @Prop({ default: () => ({}) }) readonly value!: Record<string, any>;
  @Prop({ default: false }) readonly disabled!: boolean;

  localValue: Record<string, any> = {};

  evalItems = [
    {
      key: "nyeri",
      label: "Nyeri",
      options: [
        { value: "teratasi", label: "Teratasi" },
        { value: "belum_teratasi", label: "Belum Teratasi" }
      ]
    },
    {
      key: "kecemasan",
      label: "Kecemasan",
      options: [
        { value: "terkontrol", label: "Terkontrol" },
        { value: "belum_terkontrol", label: "Belum Terkontrol" }
      ]
    },
    {
      key: "cedera",
      label: "Cedera",
      options: [
        { value: "tidak_terjadi", label: "Tidak Terjadi" },
        { value: "terjadi", label: "Terjadi" }
      ]
    },
    {
      key: "infeksi_kontrol",
      label: "Kontrol Infeksi",
      options: [
        { value: "dilakukan", label: "Dilakukan" },
        { value: "tidak_dilakukan", label: "Tidak Dilakukan" }
      ]
    },
    {
      key: "aspirasi",
      label: "Aspirasi",
      options: [
        { value: "tidak_terjadi", label: "Tidak Terjadi" },
        { value: "terjadi", label: "Terjadi" }
      ]
    },
    {
      key: "syok",
      label: "Syok",
      options: [
        { value: "tidak_terjadi", label: "Tidak Terjadi" },
        { value: "terjadi", label: "Terjadi" }
      ]
    },
    {
      key: "jatuh",
      label: "Jatuh",
      options: [
        { value: "tidak_terjadi", label: "Tidak Terjadi" },
        { value: "terjadi", label: "Terjadi" }
      ]
    },
    {
      key: "perdarahan",
      label: "Perdarahan",
      options: [
        { value: "tidak_terjadi", label: "Tidak Terjadi" },
        { value: "terjadi", label: "Terjadi" }
      ]
    }
  ];

  mounted() {
    this.localValue = { ...this.value };
  }

  @Watch("value", { deep: true })
  onValueChange(val) {
    this.localValue = { ...val };
  }

  emitChange() {
    this.$emit("input", { ...this.localValue });
  }
}
